// JUST TO HANDLE REDUX LOGIC, DISPATCHES ACTIONS, ACCESSES GLOBAL STATE
// IMPORTANT  --DO NOT DO CALLS TO (API)-- PLEASE USE SERVICE FILE

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPayrollExport } from './payrollService';

export const fetchPayrollExport = createAsyncThunk(
  'payroll/fetchPayrollExport',
  async ({ venueId, startDate, endDate }) => {
    const rows = await getPayrollExport(venueId, startDate, endDate);
    return { rows, startDate, endDate };
  }
);

const payrollSlice = createSlice({
  name: 'payroll',
  initialState: {
    data: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    startDate: null,
    endDate: null,
  },
  reducers: {
    setDateRange(state, action) {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    clearPayroll(state) {
      state.data = [];
      state.status = 'idle';
      state.error = null;
      state.startDate = null;
      state.endDate = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayrollExport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPayrollExport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.rows;
        state.startDate = action.payload.startDate;
        state.endDate = action.payload.endDate;
      })
      .addCase(fetchPayrollExport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to fetch payroll data';
      });
  },
});

export const { setDateRange, clearPayroll } = payrollSlice.actions;

// Selectors
export const selectPayrollData = (state) => state.payroll.data;
export const selectPayrollStatus = (state) => state.payroll.status;
export const selectPayrollError = (state) => state.payroll.error;
export const selectPayrollDateRange = (state) => ({
  startDate: state.payroll.startDate,
  endDate: state.payroll.endDate,
});

export default payrollSlice;
